import axiosInstance from "../utils/api";
import endpoints from "../constants/endpoints";

export const CustomerUseApi = {
    getListOfCustomerAccounts: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfCustomerAccounts}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    searchAndFilterCustomerAccount: async (searchTerm = null, orderHistory = null, account_status = 'active') => {
        try {
            const formData = new FormData();
            formData.append('search_term', searchTerm);
            formData.append('order_history', orderHistory);
            formData.append('account_status', account_status);

            const response = await axiosInstance.post(`${endpoints.searchAndFilterCustomerAccounts}`, formData);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch users: ' + error.message);
        }
    },

    getSingleCustomerAccountDetail: async (userId) => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchSingleCustomerAccount(userId)}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch user: ' + error.message);
        }
    },

    UpdateCustomerAccountDetail: async (userId, formData) => {
        try {
            const response = await axiosInstance.put(`${endpoints.updateCustomerAccount(userId)}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw new Error('Failed to update user: ' + error.message);
        }
    },

    // Enhanced registration with better error handling
    registerNewAccount: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.registerNewAccount}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Registration error:', error);
            
            // Enhanced error handling for registration
            if (error.response) {
                const status = error.response.status;
                const data = error.response.data;
                
                switch (status) {
                    case 400:
                        // Validation errors - pass through the full error data
                        throw error;
                    case 409:
                        // Conflict - user already exists
                        if (data.email) {
                            throw { response: { data: { message: "An account with this email already exists" } } };
                        } else if (data.phone_number) {
                            throw { response: { data: { message: "An account with this phone number already exists" } } };
                        } else {
                            throw { response: { data: { message: "Account already exists" } } };
                        }
                    case 422:
                        // Unprocessable entity - validation failed
                        throw error;
                    case 500:
                        // Server error
                        throw { response: { data: { message: "Server error. Please try again later." } } };
                    default:
                        throw error;
                }
            } else if (error.request) {
                // Network error
                throw { 
                    response: { 
                        data: { 
                            message: "Network error. Please check your connection and try again." 
                        } 
                    } 
                };
            } else {
                // Other error
                throw { 
                    response: { 
                        data: { 
                            message: "Registration failed. Please try again." 
                        } 
                    } 
                };
            }
        }
    },

    userNewsLetterApi: async (email) => {
        try {
            const response = await axiosInstance.post(`${endpoints.newsLaterSubscription}`, { email });
            return response.data;
        } catch (error) {
            throw new Error('Failed to subscribe to newsletter: ' + error.message);
        }
    },

    deleteCustomerAccounts: async (userIds = []) => {
        try {
            const response = await axiosInstance.post(
                `${endpoints.deleteCustomerAccounts}`,
                { user_ids: userIds }
            );
            return response.data;
        } catch (error) {
            throw new Error('Failed to delete user accounts: ' + error.message);
        }
    },

    toggleUserAccountsStatus: async (userIds = []) => {
        try {
            const response = await axiosInstance.put(
                `${endpoints.toggleUserAccountsStatus}`,
                { user_ids: userIds }
            );
            return response.data;
        } catch (error) {
            throw new Error('Failed to update user account statuses: ' + error.message);
        }
    },
};